import { writable } from 'svelte/store';

export const modeStore = writable('storyteller'); // default mode 